module.exports = __webpack_public_path__ + "img/reserved.fff086cb.svg";